// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditProfile_modalOverlay__ES-ap","modal":"EditProfile_modal__sP1DG","modalClose":"EditProfile_modalClose__reOzV","modalButtons":"EditProfile_modalButtons__4-sXc"};